interface ActionTypes {
  UNLINK_DBYD_START: string;
  UNLINK_DBYD_SUCCESS: string;
  UNLINK_DBYD_FAILURE: string;
  UPDATE_USER_PREFERENCES_START: string;
  UPDATE_USER_PREFERENCES_SUCCESS: string;
  UPDATE_USER_PREFERENCES_FAILURE: string;
  UPDATE_CONFIGURATION_START: string;
  UPDATE_CONFIGURATION_SUCCESS: string;
  UPDATE_CONFIGURATION_FAILURE: string;
  INVALIDATE_PERMALINK_START: string;
  INVALIDATE_PERMALINK_SUCCESS: string;
  INVALIDATE_PERMALINK_FAILURE: string;
  SET_EMAIL_LINKING_START: string;
  SET_EMAIL_LINKING_SUCCESS: string;
  SET_EMAIL_LINKING_FAILURE: string;
}

export const SettingsActionTypes: ActionTypes = {
  UNLINK_DBYD_START: '@@UNLINK_DBYD_START',
  UNLINK_DBYD_SUCCESS: '@@UNLINK_DBYD_SUCCESS',
  UNLINK_DBYD_FAILURE: '@@UNLINK_DBYD_FAILURE',
  UPDATE_USER_PREFERENCES_START: '@@UPDATE_USER_PREFERENCES_START',
  UPDATE_USER_PREFERENCES_SUCCESS: '@@UPDATE_USER_PREFERENCES_SUCCESS',
  UPDATE_USER_PREFERENCES_FAILURE: '@@UPDATE_USER_PREFERENCES_FAILURE',
  UPDATE_CONFIGURATION_START: '@@UPDATE_CONFIGURATION_START',
  UPDATE_CONFIGURATION_SUCCESS: '@@UPDATE_CONFIGURATION_SUCCESS',
  UPDATE_CONFIGURATION_FAILURE: '@@UPDATE_CONFIGURATION_FAILURE',
  INVALIDATE_PERMALINK_START: '@@INVALIDATE_PERMALINK_START',
  INVALIDATE_PERMALINK_SUCCESS: '@@INVALIDATE_PERMALINK_SUCCESS',
  INVALIDATE_PERMALINK_FAILURE: '@@INVALIDATE_PERMALINK_FAILURE',
  SET_EMAIL_LINKING_START: '@@SET_EMAIL_LINKING_START',
  SET_EMAIL_LINKING_SUCCESS: '@@SET_EMAIL_LINKING_SUCCESS',
  SET_EMAIL_LINKING_FAILURE: '@@SET_EMAIL_LINKING_FAILURE'
};

export interface SettingsState {
  unlinkDBYDResponse?: any;
  isUnlinkingDBYD?: boolean;
  unlinkDBYDError?: any;
  updateUserPreferencesResponse?: any;
  isUpdatingUserPreferences?: boolean;
  updateConfigurationResponse?: any;
  updateConfigurationError?: any;
  isUpdatingConfiguration?: boolean;
  configurationUpdateType?: 'emailDomains' | 'others' | 'ssoRoleMapping';
  setEmailLinkingResponse?: any;
  isSetEmailLinking?: boolean;
  invalidatingPermalink?: boolean;
  invalidatePermalinkError?: string;
  setEmailLinkingError?: any;
}
